import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import CustomToolTip from "../../../../components/CustomTooltip";
import TextButton from "../../../../components/buttons/TextButton";
import SvgToIcon from "../../../../icons/SvgToIcon";
import {
  icons,
  severities,
} from "../../../../scenes/stack/environment/icons/iconExport";
import { formatFieldName, generateMockData } from "./exportPreviewUtils";

const ExportPreview = ({
  selectedVulnerabilityFields,
  selectedEntityFields,
  onDownloadPreview,
}) => {
  const colors = useColors();

  if (
    selectedVulnerabilityFields.length === 0 &&
    selectedEntityFields.length === 0
  ) {
    return null;
  }

  const tableCellStyles = {
    fontWeight: 600,
    fontSize: "12px",
    backgroundColor: colors.grey_8percent,
    whiteSpace: "nowrap",
    padding: "8px 12px",
  };
  const tableCellTextStyles = {
    fontSize: "12px",
    color: colors.text_secondary,
    whiteSpace: "nowrap",
    padding: "8px 12px",
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Box
          display="flex"
          flexDirection="column"
          gap={0.5}
          alignItems="center"
        >
          <Box display="flex" alignItems="center" gap={0.5}>
            <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
              Export Preview
            </Typography>
            <CustomToolTip
              title="A sample set of data based on your selected fields is shown below."
              placement="top"
            >
              <SvgToIcon
                IconLogo={severities.SeverityInfoTooltipIcon}
                width="16px"
              />
            </CustomToolTip>
          </Box>
        </Box>

        <TextButton
          startIcon={icons.ActionDownloadIcon}
          onClick={onDownloadPreview}
          color="primary"
          size="small"
        >
          Download CSV Preview
        </TextButton>
      </Box>
      <TableContainer
        sx={{
          border: `1px solid ${colors.grey_48percent}`,
          borderRadius: "8px",
          maxHeight: "200px",
          overflow: "auto",
        }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  ...tableCellStyles,
                }}
              >
                Tenant
              </TableCell>
              {selectedVulnerabilityFields.map((field) => (
                <TableCell
                  key={field}
                  sx={{
                    fontWeight: 600,
                    fontSize: "12px",
                    backgroundColor: colors.grey_8percent,
                    whiteSpace: "nowrap",
                    padding: "8px 12px",
                  }}
                >
                  {formatFieldName(field)}
                </TableCell>
              ))}
              {selectedEntityFields.map((field) => (
                <TableCell
                  key={field}
                  sx={{
                    ...tableCellStyles,
                  }}
                >
                  {formatFieldName(field)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell
                sx={{
                  ...tableCellTextStyles,
                }}
              >
                tenant_123
              </TableCell>
              {selectedVulnerabilityFields.map((field) => (
                <TableCell
                  key={field}
                  sx={{
                    ...tableCellTextStyles,
                  }}
                >
                  {generateMockData(field)}
                </TableCell>
              ))}
              {selectedEntityFields.map((field) => (
                <TableCell
                  key={field}
                  sx={{
                    ...tableCellTextStyles,
                  }}
                >
                  {generateMockData(field)}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ExportPreview;
